import * as React from 'react';
import { useFela } from 'react-fela';
import { Link } from 'react-router-dom';

import type { IStyle } from 'fela';

import * as styles from './Breadcrumbs.style';
import { Box } from './generic/box/box';

import type { Theme } from '../types';

export interface Crumb {
  label: string;
  // The last crumb is the current page, so it carries no link.
  to?: string;
}

interface Props {
  crumbs: Crumb[];
  style?: IStyle;
}

const Breadcrumbs = ({ crumbs, style = {} }: Props): React.ReactElement | null => {
  const { css, theme } = useFela<Theme>();

  if (crumbs.length === 0) {
    return null;
  }

  return (
    <Box as="nav" style={{ ...styles.trail, ...style }} className="kb-breadcrumbs">
      {crumbs.map((crumb, index) => (
        // Keyed by where the crumb leads, which stays the same for a given page
        // however many crumbs sit around it. The last crumb is the current page
        // and carries no link, so it falls back to its own label.
        <React.Fragment key={crumb.to ?? `current-${crumb.label}`}>
          {index > 0 && (
            <Box as="span" style={styles.separator} className="kb-breadcrumbs__separator">
              &gt;
            </Box>
          )}
          {crumb.to ? (
            <Link to={crumb.to} className={css(styles.link(theme))}>
              {crumb.label}
            </Link>
          ) : (
            <Box as="span" style={styles.current} className="kb-breadcrumbs__current">
              {crumb.label}
            </Box>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default Breadcrumbs;
